import type React from "react"
import { cn } from "../../lib/utils"
import { MobileBottomNav } from "./mobile-bottom-nav"
import { MobileMoreMenuProvider } from "./mobile-more-menu-context"
import { MobileTopHeader } from "./mobile-top-header"
import { Sidebar } from "./sidebar"
import { SidebarStateProvider, useSidebarState } from "./sidebar-state-context"

// Inner body so it can read the sidebar state for the main-content offset.
const ShellBody: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { expanded } = useSidebarState()
	return (
		<div className="min-h-screen bg-background">
			<Sidebar />
			<MobileTopHeader />
			<MobileBottomNav />
			<main
				className={cn(
					"pt-7 pb-16 md:pt-0 md:pb-0 min-h-screen transition-[padding] duration-200 motion-reduce:transition-none",
					expanded ? "md:pl-rail-expanded" : "md:pl-rail",
				)}
			>
				{children}
			</main>
		</div>
	)
}

export const AuthenticatedShell: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => (
	<MobileMoreMenuProvider>
		<SidebarStateProvider>
			<ShellBody>{children}</ShellBody>
		</SidebarStateProvider>
	</MobileMoreMenuProvider>
)
